import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { FilterValues } from 'src/app/shared/components/filter/filter.component';
import { EStampService } from 'src/app/core/services/e-stamp.service';
import { InvoiceService } from 'src/app/core/services/invoice.service';
import { ToastService } from 'src/app/core/services/toast.service';


@Component({
    selector: 'app-bulk-orders',
    templateUrl: './bulk-orders.component.html',
    styleUrl: './bulk-orders.component.scss',
    standalone: false
})
export class BulkOrdersComponent {


  @Component({
    selector: 'app-stamp-documents',
    templateUrl: './stamp-documents.component.html',
    styleUrl: './stamp-documents.component.scss'
  })

  loading = false;
  orders = [];
  orderDetail: any = {};

  showModal: boolean = false;
  showPaymentModal: boolean = false;
  @ViewChild('dt') table!: Table;


  constructor(
    private estampService: EStampService,
    private router: Router,
    private toastService: ToastService,
    private invoiceService: InvoiceService,
  ) { }

  getStampOrders(event: LazyLoadEvent) {
    Promise.resolve().then(() => this.loading = true);
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    }

    this.estampService.getBulkOrders(queryParams).subscribe(
      (res: any) => {
        this.loading = false;
        this.orders = res?.data;
        this.totalRecords = res?.totalCount || 0;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  closeModal() {
    this.showModal = false;
    this.showPaymentModal = false;
  }

  navigateStampOrderCreate = () => {
    this.router.navigate(['/customer/estamp/create-order']);
  }

  totalRecords = 0;
  rows = 10;
  searchText: any = '';
  selectedStatus: any = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Order Created', value: 'ORDER_CREATED' },
    { label: 'Order Rejected', value: 'ORDER_REJECTED' },
    { label: 'Invoice Generated', value: 'INVOICE_GENERATED' },
    { label: 'Payment Submitted', value: 'PAYMENT_SUBMITTED' },
    { label: 'Payment Rejected', value: 'PAYMENT_REJECTED' },
    { label: 'Order Processing', value: 'ORDER_PROCESSING' },
    { label: 'Partial Fulfilled', value: 'PARTIAL_FULFILLED' },
    { label: 'Order Fulfilled', value: 'ORDER_FULFILLED' }
  ];


  onFilterChange(values: FilterValues) {
    this.searchText = values.search;
    this.selectedStatus = values.status;
    this.rangeDates = values.dateRange;
    this.table.reset();
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  downloadDocument(document: any) {
    const docUrl = document?.mergedFileUrl;

    if (!docUrl) {
      console.error('Document URL not found');
      return;
    }

    const link = window.document.createElement('a');
    link.href = docUrl;
    link.download = 'document.pdf';
    link.target = '_blank';

    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  }

  activeMenuId: string | null = null;
  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    if (!event.target.closest('.action-wrapper')) {
      this.activeMenuId = null;
    }
  }
  toggleMenu(id: string) {
    this.activeMenuId = this.activeMenuId === id ? null : id;
  }

  getOrderDetail(ord: any, type: string) {
    const id = ord?._id;
    this.estampService.getBulkOrderDetail(id).subscribe({
      next: (res: any) => {
        this.orderDetail = res?.data;
        if (type == 'payment') {
          this.showPaymentModal = true;
        } else if (type == 'invoice') {
          this.invoiceService.getStampOrderInvoice(this.orderDetail, this.orderDetail?.invoice);
        } else {
          this.showModal = true;
        }

      },
      error: () => {}
    });
  }

  protectWithPassword(document: any) {
    console.log('Protect with password:', document);
  }

  selectedFile: File | null = null;
  previewUrl: string | null = null;
  fileError: string = '';
  paymentMode: string = '';


  onFileSelect(event: any) {
    const file = event.target.files[0];

    if (!file) return;

    this.fileError = '';
    this.selectedFile = null;
    this.previewUrl = null;

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      this.fileError = 'Only JPG, JPEG, & PNG files are allowed';
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      this.fileError = 'File must be less than 2MB';
      return;
    }
    this.selectedFile = file;

    if (!this.selectedFile) return;

    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result as string;
    };

    reader.readAsDataURL(this.selectedFile);
  }

  upload: boolean = false;

  uploadFile() {
    if (this.upload) return;
    this.upload = true;
    if (!this.selectedFile || !this.paymentMode) return;

    const payload = {
      // amount: this.orderDetail?.invoice?.amount,
      // paymentMode: this.paymentMode,
      file: this.selectedFile
    }
    this.estampService.bulkPaymentSubmit(payload, this.orderDetail?._id).subscribe({
      next: (res: any) => {
        this.upload = false
        this.getStampOrders({});
        this.showPaymentModal = false;
        this.previewUrl = '';
        this.selectedFile = null;
        this.paymentMode = '';
        this.toastService.showToaster("Success", res?.message, "success");

      },
      error: (err: any) => {
        this.upload = false;
      }
    });
  }

  @ViewChild('fileInput') fileInput!: ElementRef;

  removeFile() {
    this.selectedFile = null;
    this.previewUrl = null;
    this.fileError = '';
    this.fileInput.nativeElement.value = '';
  }

  getTotalQuantity(items: any[]): number {
    return (items || []).reduce((sum, item) => sum + (item?.quantity || 0), 0);
  }

  getStatusClass(status: string): any {
    switch (status) {
      case 'ORDER_CREATED':
        return 'border-secondary text-secondary bg-light';

      case 'UNDER_REVIEW':
      case 'UNDER_CHECKER_REVIEW':
        return 'border-warning text-warning bg-warning-subtle';

      case 'INVOICE_GENERATED':
        return 'border-info text-info bg-info-subtle';

      case 'PAYMENT_SUBMITTED':
        return 'border-primary text-primary bg-primary-subtle';

      case 'PAYMENT_REJECTED':
        return 'border-danger text-danger bg-danger-subtle';

      case 'PAYMENT_VERIFIED':
        return 'border-success text-success bg-success-subtle';

      case 'ESTAMP_UPLOADED':
        return 'border-purple text-purple bg-purple-subtle';

      case 'COMPLETED':
        return 'border-success text-success bg-success-subtle';

      default:
        return 'border-dark text-dark bg-light';
    }
  }
}

